import i18next from 'i18next';

export const ORCA_PRODUCT_CODES = {
  accidentIllness: 'Accident_Illness',
  accidentOnly: 'Accident_Only',
};

export const ORCA_WELLNESS = {
  wellness: {
    code: 'Wellness1',
    value: 1,
  },
  wellness2: {
    code: 'Wellness2',
    value: 2,
  },
};

export const getOrcaPolicyCodeByName = (productName) => {
  const enCommon = i18next.getResourceBundle('en-US', 'common');
  const frCommon = i18next.getResourceBundle('fr-CA', 'common');

  switch (productName) {
    case enCommon.productName.accidentIllness:
    case frCommon.productName.accidentIllness:
      return ORCA_PRODUCT_CODES.accidentIllness;

    case enCommon.productName.accidentOnly:
    case frCommon.productName.accidentOnly:
      return ORCA_PRODUCT_CODES.accidentOnly;

    default:
      return '';
  }
};

export const getOrcaWellnessByName = (wellness) => {
  const enCommon = i18next.getResourceBundle('en-US', 'common');
  const frCommon = i18next.getResourceBundle('fr-CA', 'common');

  switch (wellness) {
    case enCommon.wellness2Name:
    case frCommon.wellness2Name:
      return ORCA_WELLNESS.wellness2;

    case enCommon.wellness1Name:
    case frCommon.wellness1Name:
      return ORCA_WELLNESS.wellness1;

    default:
      return {
        code: 0,
        name: '',
      };
  }
};
